import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(
    public http : AppHttpClient,
    public util : UtilService
  ) { }

  getTemplates(){
    return this.http.get('template-files');
  }

  downloadTemplate(templateFileId: string){
    return this.http.get('template-files', { templateFileId, download: true });
  }

  createTemplate(payload: { fileName: string, displayName: string, templateType: string, approach?: string, fileContent: string }){
    return this.http.post('template-files', payload);
  }

  updateTemplate(payload: { templateFileId: string, displayName?: string, templateType?: string, approach?: string, fileName?: string, fileContent?: string }){
    return this.http.put('template-files', payload);
  }

  deleteTemplate(templateFileId: string){
    return this.http.delete('template-files', { params: { templateFileId } });
  }

  getVersions(templateFileId: string){
    return this.http.get('template-files', { templateFileId, versions: true });
  }

  restoreVersion(templateFileId: string, versionId: string){
    return this.http.put('template-files?restoreVersion=' + versionId, { templateFileId });
  }
}
